import { render } from "./QRRequest.vue?vue&type=template&id=65315b68"
import script from "./QRRequest.vue?vue&type=script&lang=js"
export * from "./QRRequest.vue?vue&type=script&lang=js"

import "./QRRequest.vue?vue&type=style&index=0&id=65315b68&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__